<template>
  <ul v-if="!$store.getters['app/isApp']" class="social-bookmarks">
    <li class="mr-2 inline-block">
      <share-to-facebook :text="text" :url="url" />
    </li>
    <li class="mr-2 inline-block">
      <share-to-twitter :text="text" :url="url" />
    </li>
    <li class="mr-2 inline-block">
      <share-to-whatsapp :text="text" :url="url" />
    </li>
    <li class="mr-2 inline-block">
      <share-to-facebook-messenger :text="text" :url="url" />
    </li>
    <!-- <li class="inline-block mr-2">
      <share-to-mail
        :text="text"
        :url="url"
       />
    </li> -->
    <li class="mr-2 inline-block">
      <share-to-clipboard :text="text" :url="url" />
    </li>
  </ul>
</template>

<script>
import ShareToFacebook from '../../social/ShareToFacebook.vue'
import ShareToTwitter from '../../social/ShareToTwitter.vue'
import ShareToWhatsapp from '../../social/ShareToWhatsapp.vue'
import ShareToFacebookMessenger from '../../social/ShareToFacebookMessenger.vue'
// import ShareToMail from '../../social/ShareToMail.vue'
import ShareToClipboard from '../../social/ShareToClipboard.vue'

export default {
  components: {
    ShareToFacebook,
    ShareToTwitter,
    ShareToWhatsapp,
    ShareToFacebookMessenger,
    // ShareToMail,
    ShareToClipboard,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style>
@import '~components/content/widgets/SocialBookmarks.css';
</style>
